export class Group {
    public GroupId: number;
    public GroupName: string;
}
